exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading-positon[data-v-21a492fd] {\n  top: 50%;\n  left: 45%;\n}\n", ""]);

// exports
